import React, { useState, useEffect, forwardRef } from "react";
import { Row, Col } from "antd";
import ReadOnlyItem from "../../../components/forms/ReadOnlyItem";
import {
  BankBranchesSelect,
  MetaDataSelect,
} from "../../../components/forms/AutoCompleteFormItem";
import { getBankBranches } from "../../../api/server";
import { useBanks } from "../../../hooks";
import { useSelector } from "react-redux";
import Surface from "../../../components/layouts/Surface";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import { FormattedMessage } from "react-intl";
import FormHeader from "../../../components/forms/FormHeader";
import { InputItem } from "../../../components/forms/FormItems";

const Form101Bank = forwardRef((props, ref) => {
  const banks = useBanks();
  const [bankId, setBankId] = useState(null);
  const [branchId, setBranchId] = useState(null);
  const [bankCode, setBankCode] = useState(null);
  const [branchDetails, setBranchDetails] = useState(null);
  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );
  useEffect(() => {
    setBankId(activeEmployee ? activeEmployee.bank_acccount.bank_id : null);
    if (
      activeEmployee &&
      activeEmployee.bank_acccount.bank_id !== undefined &&
      activeEmployee.bank_acccount.branch_id !== undefined
    ) {
      setDetails();
    }
  }, [banks]);

  useEffect(() => {
    setDetails();
  }, [branchId]);

  const onBankChange = (id) => {
    setBankId(id);
    setBranchDetails(null);
  };

  const onBranchChange = (id) => {
    setBranchId(id);
  };
  const setDetails = () => {
    const id = bankId ? bankId : activeEmployee.bank_acccount.bank_id;
    const brId = branchId ? branchId : activeEmployee.bank_acccount.branch_id;
    const code = banks.filter((i) => i.id === id)[0]
      ? banks.filter((i) => i.id === id)[0].code
      : null;
    setBankCode(code);
    if (id) {
      getBankBranches({ id }).then(({ error, data }) => {
        const item = data.items.filter((item) => item.id === brId)[0];
        setBranchDetails(item);
      });
    }
  };
  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.employees.bankAccountDetails" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={8} xxl={8}>
            <MetaDataSelect
              name="bank_acccount.bank_id"
              category="employee"
              metadataName={"banks"}
              onChange={onBankChange}
            />
            {bankId ? (
              <BankBranchesSelect
                name="bank_acccount.branch_id"
                category="employee"
                extraParams={{ id: bankId }}
                onChange={onBranchChange}
                disabled={bankId === undefined}
              />
            ) : null}

            <InputItem
              name="bank_acccount.number"
              category="employee"
              onlyNumbers={true}
            />
          </Col>

          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={{ span: 12, offset: 2 }}
            xxl={8}
          >
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                {branchDetails ? (
                  <ReadOnlyItem
                    content={branchDetails.city}
                    name="bank_branch_city"
                    category="employee"
                  />
                ) : null}
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                {branchDetails ? (
                  <ReadOnlyItem
                    content={branchDetails.phone_number}
                    name="bank_branch_phone_number"
                    category="employee"
                  />
                ) : null}
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                {branchDetails ? (
                  <ReadOnlyItem
                    content={bankCode}
                    name="bank_branch_bank_code"
                    category="employee"
                  />
                ) : null}
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                {branchDetails ? (
                  <ReadOnlyItem
                    content={branchDetails.branch_code}
                    name="bank_branch_branch_code"
                    category="employee"
                  />
                ) : null}
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                {branchDetails ? (
                  <ReadOnlyItem
                    content={branchDetails.address}
                    name="bank_branch_address"
                    category="employee"
                  />
                ) : null}
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                {branchDetails ? (
                  <ReadOnlyItem
                    content={branchDetails.postal_code}
                    name="bank_branch_postal_code"
                    category="employee"
                  />
                ) : null}
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
    </div>
  );
});

export default Form101Bank;
